import { useEffect, useState } from "react";

// Cursor paw-print trail
export function CursorPaws() {
  useEffect(() => {
    let last = 0;
    const paw = (x, y) => {
      const now = Date.now();
      if (now - last < 90) return;
      last = now;
      const el = document.createElement("div");
      el.className = "paw-trail";
      el.style.left = x - 11 + "px";
      el.style.top = y - 11 + "px";
      el.innerHTML = `<svg viewBox="0 0 24 24" fill="#FF8A3D" opacity="0.65"><circle cx="6" cy="9" r="2.2"/><circle cx="12" cy="6.5" r="2.2"/><circle cx="18" cy="9" r="2.2"/><circle cx="9" cy="13" r="2.2"/><ellipse cx="12" cy="18" rx="4.5" ry="3.6"/></svg>`;
      document.body.appendChild(el);
      requestAnimationFrame(() => { el.style.opacity = "0"; el.style.transform = "translateY(10px) scale(0.7)"; });
      setTimeout(() => el.remove(), 650);
    };
    const move = (e) => paw(e.clientX, e.clientY);
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);
  return null;
}

// Animated gradient blobs background
export function Blobs() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <div className="absolute -top-24 -left-24 w-[28rem] h-[28rem] rounded-full bg-woofsy-primary/25 blur-3xl animate-blob" />
      <div className="absolute top-1/3 -right-24 w-[26rem] h-[26rem] rounded-full bg-woofsy-secondary/35 blur-3xl animate-blob" style={{ animationDelay: "3s" }} />
      <div className="absolute -bottom-24 left-1/4 w-[24rem] h-[24rem] rounded-full bg-woofsy-accent/30 blur-3xl animate-blob" style={{ animationDelay: "6s" }} />
    </div>
  );
}

// Interactive floating bubbles that pop on click
export function FloatingBubbles({ count = 14 }) {
  const [bubbles, setBubbles] = useState(() =>
    Array.from({ length: count }, (_, i) => ({
      id: i, left: Math.random() * 100, size: 16 + Math.random() * 42,
      delay: Math.random() * 8, dur: 8 + Math.random() * 8,
    }))
  );
  const pop = (id) => setBubbles((b) => b.filter((x) => x.id !== id));
  useEffect(() => {
    if (bubbles.length >= count) return;
    const t = setTimeout(() => setBubbles((b) => [...b, {
      id: Date.now(), left: Math.random() * 100, size: 16 + Math.random() * 42,
      delay: 0, dur: 8 + Math.random() * 8,
    }]), 1200);
    return () => clearTimeout(t);
  }, [bubbles, count]);
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {bubbles.map((b) => (
        <span key={b.id} data-testid="floating-bubble" onClick={() => pop(b.id)}
          className="bubble"
          style={{
            left: b.left + "%", bottom: "-60px", width: b.size, height: b.size,
            animation: `rise ${b.dur}s linear ${b.delay}s infinite`,
          }} />
      ))}
    </div>
  );
}

export function PawPrint({ className = "", style }) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={style} fill="currentColor" aria-hidden>
      <circle cx="6" cy="9" r="2.2" /><circle cx="12" cy="6.5" r="2.2" />
      <circle cx="18" cy="9" r="2.2" /><circle cx="9" cy="13" r="2.2" />
      <ellipse cx="12" cy="18" rx="4.5" ry="3.6" />
    </svg>
  );
}
